module.exports = __webpack_public_path__ + "af45812a7afa106fe0e325ca0d60e6a2.svg";